import { render } from "./DivertPower.vue?vue&type=template&id=544416f4"
import script from "./DivertPower.vue?vue&type=script&lang=js"
export * from "./DivertPower.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__